import {
  meilisearchAutocompleteClient,
  type InstantMeiliSearchInstance,
} from "@meilisearch/autocomplete-client";
import Logger from "@cappelendamm/logger";

function createUnavailableAutocompleteClient() {
  return {
    search: async () => ({ hits: [], nbHits: 0 }),
  } as unknown as InstantMeiliSearchInstance;
}

const host = process.env.NEXT_PUBLIC_MEILISEARCH_URL;
const apiKey = process.env.NEXT_PUBLIC_MEILISEARCH_NETTHANDEL_SEARCH_KEY;

export const autocompleteClient =
  host && apiKey
    ? meilisearchAutocompleteClient({
        url: host,
        apiKey,
        options: {
          primaryKey: "objectID",
        },
      })
    : (Logger.error(
        "One or more MeiliSearch environment variables are not defined",
      ),
      createUnavailableAutocompleteClient());
